import { ISim } from '@interfaces/sim.interace';

export class SimContextModel {
    id: string;
    isCurrent: boolean;
    isCompatible: boolean;
    sims: ISim[];

    constructor(data: Partial<SimContextModel>) {
        Object.assign(this, data);
    }

    public isSimCompatible(gencode: string): boolean {
        return this.sims.find((sim) => sim.gencode === gencode)?.isCompatibleTerminal || false;
    }
}
